export const classes = {
  wrapper: 'relative place-center size-full overflow-hidden',
};
